import { Button } from "@tellescope/design-system";
import { usePrintNode } from "@tellescope/react-hooks";
import { Printer } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { FormResponse } from "@tellescope/types-models";
import { PrintableResponse } from "./PrintableResponse";

interface PrintResponseButtonProps {
  formResponse: FormResponse;
}

/**
 * The thanks screen's "get a copy of your answers" action, for forms that set `publicShowDownload`.
 *
 * Prints rather than writing a file: the browser's print dialog already offers "Save as PDF", which
 * reaches legacy's outcome without shipping a PDF renderer — legacy's download button pulled in
 * jsPDF plus the email/fax drawer it was bundled with, none of which a patient needs.
 */
export const PrintResponseButton = ({ formResponse }: PrintResponseButtonProps) => {
  const { t } = useTranslation("forms");
  const { print, PrintPortal } = usePrintNode();

  return (
    <>
      <Button variant="outline" onClick={print}>
        <Printer className="h-4 w-4 mr-2" />
        {t("Print a copy")}
      </Button>
      <PrintPortal>
        <PrintableResponse formResponse={formResponse} />
      </PrintPortal>
    </>
  );
};
